import { localize } from '../i18n';
import useNavigate from '../hooks/useSafeNavigate';
import SingleLineText from './ui/SingleLineText';
import Button from './ui/FitButton';
import { needsRelease105Update } from '../utils/release105Access';
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { getAccount, getDeviceUuid } from '../api';
import useRequestGuard from '../hooks/useRequestGuard';
import { readAlertRuntimeInfo } from '../utils/alertMethodSupport';
import { supportsAccountLogin } from '../utils/accountAccess';

export default function FamilyAccountNotice() {
    const navigate = useNavigate();
    const [signedOut, setSignedOut] = useState(false);
    const [runtimeInfo, setRuntimeInfo] = useState(() => readAlertRuntimeInfo());
    const beginRequest = useRequestGuard('family-account');
    useEffect(() => {
        const update = event => setRuntimeInfo(event?.detail || readAlertRuntimeInfo());
        window.addEventListener('app-runtime-info-updated', update);
        return () => window.removeEventListener('app-runtime-info-updated', update);
    }, []);
    useEffect(() => {
        const isCurrent = beginRequest();
        getAccount(getDeviceUuid()).then(account => {
            if (isCurrent()) setSignedOut(account?.linked === false);
        }).catch(() => {});
    }, [beginRequest]);

    if (!signedOut || !(supportsAccountLogin(runtimeInfo) || needsRelease105Update(runtimeInfo))) return null;
    return (
        <Box sx={{ mb: 2, px: 1.5, py: 0.5, borderRadius: 3, bgcolor: '#f7f7f7',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
            <SingleLineText sx={{ fontSize: '0.875rem', color: '#777', wordBreak: 'keep-all' }}>{localize("기존 가족 연결이 있나요?")}</SingleLineText>
            <Button variant="text" aria-label={localize("로그인해서 불러오기")} onClick={() => navigate('/settings?account=login')}
                sx={{ minWidth: 0, minHeight: 44, px: 0.5, flexShrink: 0, borderRadius: 2,
                    color: '#8a7000', fontSize: '0.875rem', fontWeight: 700, '&:hover': { bgcolor: '#fffbeb' } }}>{localize("로그인")}</Button>
        </Box>
    );
}
